import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class CriteriosEvaluadorServices {
  getCriteriosEvaluador = (params) =>
    AxiosClient.get("/api/app/evaluacion_configuracion_seleccion_evaluador/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCriterioEvaluador = (id) =>
    AxiosClient.get(`/api/app/evaluacion_configuracion_seleccion_evaluador/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCriteriosEvaluador = (data) =>
    AxiosClient.post("/api/app/evaluacion_configuracion_seleccion_evaluador/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCriteriosEvaluador = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_configuracion_seleccion_evaluador/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteCriteriosEvaluador = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_configuracion_seleccion_evaluador/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CriteriosEvaluadorServices();
